import styled from "styled-components";

export const CategoryPreviewContainer = styled.div`
  margin-top: 4.8rem;
`;

export const Title = styled.span`
  display: inline-block;
  padding: 0 4.8rem 0;
  font-size: 3.6rem;
  letter-spacing: 0.5px;
  font-weight: 700;
  margin-bottom: 0.6rem;
`;

export const SwiperContainer = styled.div`
  margin: 2.4rem 4.8rem 3.6rem 4.8rem;
`;
